import { IMaterialInputProps } from 'app/components/material/MaterialInput'
import { QuestionsGroupMediator } from 'app/components/questions/mediator'
import { RetirementUnits } from 'app/redux/Profile/model'
import * as utils from 'app/utils'
import * as React from 'react'

interface IQuestionsGroupProps {
  header: string
  icon: string
}

// tslint:disable-next-line:no-empty-interface
interface IQuestion extends IMaterialInputProps {
  name: string
  placeholder: string
  unit?: RetirementUnits
  needsSpouse?: boolean
}

const annualizedFootnoteFormatter = (e: any): any => {
  const v = utils.toNumber(e)
  return (0 === v) ? '' : 'On a yearly basis, this is ' + utils.toCurrency(v * 12)
}

const monthlyFootnoteFormatter = (e: any): any => {
  const v = utils.toNumber(e)
  return (0 === v) ? '' : 'On a monthly basis, this is ' + utils.toCurrency(v / 12)
}

abstract class QuestionsGroup<P extends IQuestionsGroupProps, S> extends React.Component<P, S> {

  getValueForQuestion(questionName: string) {
    return QuestionsGroupMediator.getValueForQuestion(questionName)
  }
}

export {
  annualizedFootnoteFormatter,
  monthlyFootnoteFormatter,
  QuestionsGroup,
  IQuestion,
  IQuestionsGroupProps,
}



// WEBPACK FOOTER //
// ./src/app/components/questions/base.tsx